import React from "react";
import Marquee from "react-fast-marquee";

const EditorialMarquee = ({ words }) => (
  <div className="bg-[#141416] border-y border-line py-6 overflow-hidden">
    <Marquee speed={38} gradient={false} autoFill>
      {words.map((w, i) => (
        <span key={i} className="flex items-center">
          <span className="font-serif text-4xl md:text-6xl text-ash/70 italic px-8">{w}</span>
          <span className="text-crimson text-2xl">✦</span>
        </span>
      ))}
    </Marquee>
  </div>
);

export default EditorialMarquee;
